import MenuItem from "@mui/material/MenuItem";
import MuiSelect from "@mui/material/Select";
import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  ListSubheader,
  TextField,
  IconButton,
  Divider,
  Checkbox,
  Chip
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState, useEffect, useRef, useMemo } from "react";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import SearchIcon from "@mui/icons-material/Search";

export default function Select({
  items = [],
  multiple,
  value: selected,
  handleChange,
  IsSelectAll,
  Propwidth,
  ...props
}) {
  const [selectedValue, setSelectedValue] = useState(multiple ? [] : " ");
  const [openSelectOptions, setOpenSelectOptions] = useState(false);
  const [searchText, setSearchText] = useState("");
  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(0);

  useEffect(() => {
    if (parentRef.current) {
      const width = parentRef.current.offsetWidth;
      setParentWidth(width);
    }
  }, []);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: Propwidth ? 320 : 250,
        minWidth: parentWidth
      }
    },
    autoFocus: false // Disable autofocus
  };

  useEffect(() => {
    if (selected) {
      setSelectedValue(selected);
    } else {
      setSelectedValue(multiple ? [] : "");
    }
  }, [selected]);

  function onChange(event) {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    handleChange?.(newValue);
  }

  const handleMultiSelectOpen = () => {
    setOpenSelectOptions(true);
  };

  const handleMultiSelectClose = () => {
    setOpenSelectOptions(false);
    setSearchText("")
  };

  const handleSearchInputChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredItems = items?.filter((item) =>
    item?.text?.toLowerCase()?.includes(searchText?.toLowerCase())
  );

 
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      const allValues = items?.filter(item => !item.headding).map(item => item.value);
      onChange({ target: { value: allValues } });
    } else {
      onChange({ target: { value: [] } });
    }
    setSelectAll(event.target.checked);
  };

  useEffect(() => {
    if (selectedValue?.length === items?.filter(item => !item?.headding).length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedValue, items]);
  if (multiple) {
    return (
      <FormControl fullWidth>
      <MuiSelect
        ref={parentRef}
        {...props}
        sx={{
          "& legend": { display: "none" },
          "& fieldset": { top: 0 },
          width: Propwidth ? "320px" : "90px"
        }}
        className="select-input"
        variant="outlined"
        value={selectedValue}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        multiple={multiple}
        MenuProps={MenuProps}
        open={openSelectOptions}
        onOpen={handleMultiSelectOpen}
        onClose={handleMultiSelectClose}
        renderValue={(selected) => (
          <Box sx={{ flexWrap: "wrap", gap: 0.5 }}>
            {selected?.map((value) => (
              <Chip
                sx={{ marginRight: "10px" }}
                key={value}
                label={items?.find((i) => i.value === value)?.text}
                hidden={
                  items?.find((i) => i.value === value)?.text ? false : true
                }
              />
            ))}
          </Box>
        )}
      >
        <Box sx={{ display: "flex", alignItems: "center", px: 1,marginBottom:"10px" }}>
          <TextField
            size="small"
            placeholder="Search..."
            value={searchText}
            onChange={handleSearchInputChange}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
          <IconButton size="small" onClick={handleMultiSelectClose}>
            <CancelSharpIcon />
          </IconButton>
        </Box>
        <Divider />
     
        <MenuItem hidden={searchText?.length!=0||IsSelectAll==false}>
          <Checkbox
               id="select-all-checkbox"
            checked={selectAll}
            onChange={handleSelectAllChange}
          />
             <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                    Select All
                  </label>
        </MenuItem>
        {filteredItems?.map((item) =>
          item.headding ? (
            <ListSubheader key={item.headding}>{item.headding}</ListSubheader>
          ) : (
            <MenuItem key={item.value} title={item.text} value={item.value}>
              <Checkbox checked={selectedValue.indexOf(item.value) > -1} />
              {item.text}
            </MenuItem>
          )
        )}
      </MuiSelect>
    </FormControl>
    );
  }
  return (
    <FormControl fullWidth>
      <MuiSelect
        {...props}
        ref={parentRef}
        className="select-input"
        variant="outlined"
        value={selectedValue}
        onChange={onChange}
        MenuProps={MenuProps}
        IconComponent={KeyboardArrowDownIcon}
        onClose={handleMultiSelectClose}
        sx={{
          "& legend": { display: "none" },
          "& fieldset": { top: 0 },
          color: "black",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#667085",
            border: "1px solid #667085"
          }
        }}

      >
        <Box sx={{ display: "flex", alignItems: "center", px: 1 }}>
          <TextField
            size="small"
            placeholder="Search..."
            value={searchText}
            onChange={handleSearchInputChange}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
   
                e.stopPropagation();
              }
            }}
          />
             <IconButton size="small" onClick={handleMultiSelectClose}>
            <CancelSharpIcon />
          </IconButton>
        </Box>
        {filteredItems?.map((item) =>
          item.headding ? (
            <ListSubheader key={item.headding}>{item.headding}</ListSubheader>
          ) : (
            <MenuItem key={item.value} title={item.text} value={item.value}>
              {item.text}
            </MenuItem>
          )
        )}
      </MuiSelect>
    </FormControl>
  );
}
